import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import { StyledPlansTable } from './plans-table.style'
import Button from '../../buttons/buttons.component'
import { PlansLogoRouter } from '../../plans-logos'
import { ClientService } from '../../../services/client.service'
import { ClubService } from '../../../services/club.service'

/**
 * @param {string} selectedPlanId
 * Id of the selected plan
 *
 * @param {boolean} logged
 * True if user is logged in
 *
 * @param {boolean} notBuyable
 * Hides buttons to buy a plan
 *
 * @param {function} onSelect
 * callback for when user selects a plan
 *
 * @param {function} onButtonClick
 * function  the receives the plan ID and return a callback
 */
class PlansTable extends Component {
	state = {
		plans: [],
		selectedPlanId: '',
		recurrenceType: null
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.planId != nextProps.planId) this.loadPlans()
	}

	componentWillMount() {
		this.loadPlans()
	}

	loadPlans() {
		if (this.props.logged)
			ClientService.getPlans().then(
				({ data: plans, success }) => success && this.setState({ plans })
			)
		else
			ClubService.getPlans().then(plans => {
				this.setState({ plans })
			})
	}

	render() {
		const { selectedPlanId, plans, recurrenceType } = this.state
		const {
			notBuyable,
			planId,
			logged,
			onButtonClick,
			subscribedPlan
		} = this.props

		const orderById = (a, b) => a.id - b.id

		return (
			<StyledPlansTable>
				<div className="buttons">
					{plans.sort(orderById).map(({ name, id }) => (
						<div
							key={id}
							className={`button ${selectedPlanId &&
								selectedPlanId === id &&
								'active'}`}
							onClick={() => selectPlan.call(this, id, 'monthly')}>
							{name}
						</div>
					))}
				</div>

				<div className="table">
					{plans.map(
						({
							id,
							pointsPerMonth,
							bonusPointsPerMonth,
							pointsValidity,
							benefit,
							annualNumberOfPoints,
							amount,
							annualAmmount,
							annualPercentageDiscount,
							canSubscribe
						}) => {
							const getPlanClassName = type =>
								`${type} ${
									recurrenceType
										? recurrenceType === type && selectedPlanId === id
											? 'active'
											: 'not-active'
										: ''
								} ${
									(canSubscribe != undefined && !canSubscribe) ||
									(subscribedPlan &&
										subscribedPlan.recurrenceType.toLowerCase() !=
											type)
										? 'disabled'
										: ''
								}`

							const getPlanAction = type => {
								planId != id &&
								(canSubscribe === undefined || canSubscribe) &&
								(!subscribedPlan ||
									subscribedPlan.recurrenceType.toLowerCase() == type)
									? selectPlan.call(this, id, type)
									: null
							}

							return (
								<div
									className={`column ${selectedPlanId &&
										id === selectedPlanId &&
										'active'}`}
									key={id}>
									<div className="header">
										<PlansLogoRouter id={id} fontSize="36" />
									</div>
									<div>
										{' '}
										<FontAwesome name="check" /> {pointsPerMonth}{' '}
										pontos todo mês
									</div>
									<div>
										<FontAwesome name="check" />{' '}
										<span className="orange">
											Promoção + {bonusPointsPerMonth} pontos bônus
											todo mês
										</span>
									</div>
									<div>
										<FontAwesome name="check" />
										{pointsValidity
											? ` Validade dos pontos: ${pointsValidity}`
											: ' Pontos não expiram'}
									</div>
									<div>
										<FontAwesome name="check" />
										{' ' + benefit}
									</div>
									<div>
										<FontAwesome name="check" /> Em 12 meses você
										acumula{' '}
										{Number(annualNumberOfPoints).toLocaleString(
											'pt-BR'
										)}{' '}
										pontos
									</div>
									<div>
										<FontAwesome name="check" /> Desconto na compra de passagens										
									</div>
									<div
										className={getPlanClassName('monthly')}
										onClick={() => getPlanAction('monthly')}>
										Assinar Mensal {Number(amount).$toReais()}
										/mês
									</div>
									<div
										className={getPlanClassName('yearly')}
										onClick={() => getPlanAction('yearly')}>
										Assinar Anual À Vista{' '}
										<span className="blue">
											{Number(annualAmmount).$toReais()}
											/ano
										</span>
										<br />
										<span className="light-orange">
											<FontAwesome name="certificate" />
											{' ' + annualPercentageDiscount}% OFF
										</span>
									</div>
									{notBuyable || (
										<Button
											primary={planId != id}
											secondary={planId == id}
											disabled={
												(logged && !canSubscribe) ||
												planId == id ||
												selectedPlanId != id
											}
											onClick={
												onButtonClick &&
												onButtonClick(id, recurrenceType)
											}>
											{(!logged || subscribedPlan === null)
												? 'Assinar'
												: (planId == id
												? 'Seu plano'
												: 'Alterar plano')}
										</Button>
									)}
								</div>
							)
						}
					)}
				</div>
			</StyledPlansTable>
		)
	}
}

function selectPlan(id, type) {
	const { onSelect } = this.props

	this.setState({ selectedPlanId: id, recurrenceType: type })
	onSelect && onSelect(id, type)
}

const mapStateToProps = ({ user }) => ({
	planId: user && user.plan ? user.plan.planId : null,
	subscribedPlan: (user && user.plan) || null
})

const connectedPlansTable = connect(
	mapStateToProps,
	null
)(PlansTable)

export { connectedPlansTable as PlansTable }
